@if (isExpanded() && (title() || hasCustomTitle)) {
  <div class="title">
    @if (entityNumber()) {
      <procure-entity-badge
        [label]="entityNumber()"
        [linked]="false"
      />
      <procure-copy-button
        class="copy"
        tooltip="Copy link"
        isUrl
        [value]="`/${entityNumber()}`"
      />
    } @else if (hasCustomTitle) {
      <ng-content select="[title]" />
    } @else {
      {{ title() }}
    }
  </div>
}
<div
  class="menu"
  [class.expanded]="isExpanded() && !icons()"
  [class.bottom]="bottom()"
>
  <div class="list">
    <ng-content />
  </div>
</div>
